import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const initialState = {
  attendanceData: {},
  isLoading: false,
};

const attendanceSlice = createSlice({
  name: "attendance",
  initialState,
  reducers: {
    markPresent: (state, action) => {
      const {
        id,
        status,
        daysInMonth,
        getValues,
        checkIsPublicHoliday,
        publicHolidays,
        watch,
      } = action.payload;

      for (let i = 0; i < daysInMonth; i++) {
        markAttendanceForDay(
          id,
          i,
          status,
          getValues,
          checkIsPublicHoliday,
          publicHolidays,
          watch,
          state
        );
      }
    },

    inTimeChange: (state, action) => {
      const { id, row, value } = action.payload;
      state.attendanceData[id] = state.attendanceData[id] || {};
      state.attendanceData[id][row] = state.attendanceData[id][row] || {};
      state.attendanceData[id][row].attendanceInTime = value;
      console.log(state.attendanceData[id])
      // state.attendanceData[id][row].totalHours = calculateTotalHours(
      //   value,
      //   value
      // );
    },

    outTimeChange: (state, action) => {
      const { id, row, value } = action.payload;
      state.attendanceData[id] = state.attendanceData[id] || {};
      state.attendanceData[id][row] = state.attendanceData[id][row] || {};
      state.attendanceData[id][row].attendanceOutTime = value;
      
      // state.attendanceData[id][row].totalHours = calculateTotalHours(
      //   value,
      //   value
      // );
    },

    markAll: (state, action) => {
      const {
        status,
        employeeAttendanceList,
        daysInMonth,
        getValues,
        checkIsPublicHoliday,
        publicHolidays,
        watch,
      } = action.payload;

      employeeAttendanceList?.forEach((data) => {
        for (let i = 0; i < daysInMonth; i++) {
          markAttendanceForDay(
            data.employeeCode,
            i,
            status,
            getValues,
            checkIsPublicHoliday,
            publicHolidays,
            watch,
            state
          );
        }
      });
    },

    chooseAttendance: (state, action) => {
      const { id, row, value, scheduleMap, getValues, userData } =
        action.payload;
      setAttendance(state, id, row, value, scheduleMap, getValues, userData);
    },

    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

const setAttendance = (
  state,
  id,
  row,
  attendanceValue,
  scheduleMap,
  getValues,
  userData
) => {
  const schedule = scheduleMap[`${id}-${getValues(`attendanceDate[${row}]`)}`];

  let startTime =
    attendanceValue === 0
      ? "00:00:00"
      : moment(schedule?.shiftInTimeStr, ["HH:mm"], true).isValid()
      ? moment(schedule?.shiftInTimeStr, ["HH:mm"]).format("HH:mm:ss")
      : moment(userData?.companyOpenTime, ["HH:mm"]).format("HH:mm:ss");

  let endTime =
    attendanceValue === 1
      ? moment(schedule?.shiftOutTimeStr, ["HH:mm"], true).isValid()
        ? moment(schedule?.shiftOutTimeStr, ["HH:mm"]).format("HH:mm:ss")
        : moment(userData?.companyCloseTime, ["HH:mm"]).format("HH:mm:ss")
      : moment(startTime, ["HH:mm"]).add(4, "hours").format("HH:mm:ss");

  state.attendanceData[id] = state.attendanceData[id] || {};
  state.attendanceData[id][row] = {
    attendanceValue: Number(attendanceValue),
    scheduleId: schedule ? schedule?.scheduleId : 0,
    isCheck: true,
    attendanceInTime: startTime,
    attendanceOutTime: endTime,
    totalHours: calculateTotalHours(startTime, endTime),
  };
};

const calculateTotalHours = (startTime, endTime) => {
  const [hours1, minutes1] = startTime.split(":");
  const [hours2, minutes2] = endTime.split(":");

  const date1 = new Date();
  date1.setHours(hours1);
  date1.setMinutes(minutes1);

  const date2 = new Date();
  date2.setHours(hours2);
  date2.setMinutes(minutes2);

  const diff = date2 - date1;
  const hoursDiff = Math.floor(diff / (1000 * 60 * 60));
  const minutesDiff = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

  return `${hoursDiff}:${minutesDiff}:00`;
};

const markAttendanceForDay = (
  employeeCode,
  dayIndex,
  isPresent,
  getValues,
  checkIsPublicHoliday,
  publicHolidays,
  watch,
  state
) => {
  const isPublicHoliday = checkIsPublicHoliday(
    publicHolidays,
    getValues(`attendanceDate[${dayIndex}]`)
  );
  const restData = watch(`restDay[${employeeCode}]`)?.split(",") || [];

  const fullRestDay = restData
    .filter((v) => v.includes("-1"))
    .map((d) => d?.split("-")[0]);
  const halfRestDay = restData
    .filter((v) => v.includes("-0.5"))
    .map((d) => d?.split("-")[0]);

  const day = moment(getValues(`attendanceDate[${dayIndex}]`)).format("dddd");
  const isRestDay = fullRestDay.includes(day);
  const isHalfRestDay = halfRestDay.includes(day);

  setAttendance(
    state,
    employeeCode,
    dayIndex,
    isPresent && !(isRestDay || isPublicHoliday || isHalfRestDay)
      ? 1
      : isHalfRestDay
      ? 0.5
      : 0,
    {},
    getValues,
    {}
  );
};

export const {
  markPresent,
  inTimeChange,
  outTimeChange,
  markAll,
  chooseAttendance,
  setLoading,
} = attendanceSlice.actions;

export const attendanceReducer = attendanceSlice.reducer;
